<template>
    <div :class="containerClass" @click="onWrapperClick" v-if="this.$store.getters.isAuthenticated && this.$store.getters.userToken">
        <AppTopBar @menu-toggle="onMenuToggle" @show-toast="toastNow" />
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <div class="col-12 text-900 text-2xl font-medium mb-3">{{ this.$route.name }}</div>
                <router-view @show-toast="toastNow" :key="this.$route.fullPath"/>
            </div>
            <AppFooter />
        </div>

        <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
    </div>
    <div v-if="!this.$store.getters.isAuthenticated && !this.$store.getters.userToken">
        <router-view @show-toast="toastNow"/>
    </div>
    <Toast position="top-center"/>
    <Dialog v-if="this.$store.getters.getLoading" v-model:visible="this.$store.getters.getLoading" modal header="Loading" :closable="false"
        :style="{ width: '10vw' }">
        <ProgressBar mode="indeterminate" style="height: 6px;"></ProgressBar>
    </Dialog>
	<SessionAlertModal v-model:visible="displaySessionAlert" @sessionLogout="sessionLogout()" @keepSession="keepSession()"></SessionAlertModal>
</template>

<script>
import AppTopBar from '@/shared/layout/AppTopbar.vue';
import AppMenu from '@/shared/layout/AppMenu.vue';
import AppConfig from '@/shared/layout/AppConfig.vue';
import AppFooter from '@/shared/layout/AppFooter.vue';
import MenuService from "@/service/MenuService";
import { useToast } from "primevue/usetoast";
import authStore from './core/services/authStore/authStore';
import ApiAuthService from './service/api/apis/ApiAuthService';
import SessionAlertModal from '@/shared/components/SessionAlertModal';

export default {
    emits: ['change-theme'],
    data() {
        return {
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu: null,
            toast: '',
            displaySessionAlert: false,
        }
    },
    menuService: null,
    created() {
        this.menuService = new MenuService();
        this.toast = useToast();
        this.apiAuthService = new ApiAuthService();
        window.addEventListener('click', this.updateLastActive);
        window.addEventListener('keydown', this.updateLastActive);
    },
    async mounted() {
        if(authStore.getters.isAuthenticated || authStore.getters.userToken){
            try {
                const data = await this.menuService.getMenus();
                this.menu = [data];
            } catch (error) {
                console.error("Error fetching menus:", error);
            }
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
        '$store.state.auth.showToast'(newVal) {
            if(newVal.severity){
                setTimeout(() => {
                    this.toastNow(newVal.severity,newVal.title,newVal.message);  
                    authStore.commit('setShowToast',{})  
                }, 500);
            }
        },
        '$store.state.auth.isAuthenticated'(newVal) {
            if(newVal == false){
                try {
                    if(this.$store.getters.userToken){
                        this.apiAuthService.LogOut()
                        this.$router.push("/auth/login");
                    }
                } catch (error) {
                    console.log(error);
                }
            }else{
                this.menuService.getMenus().then(data => this.menu = [data]);
            }
        },   
    },
    methods: {
        updateLastActive(){
            const lastActive = authStore.getters.lastActive
            const loginAt = authStore.getters.loginAt
            const currentTime = new Date();
            const inactivityDuration = currentTime - lastActive;
            const lastLoginDuration  = currentTime - loginAt;
            if (inactivityDuration >= 30 * 60 * 1000 ) {
                this.displaySessionAlert = true
            }
            if(lastLoginDuration >= 24 * 60 * 60 * 1000){
                this.sessionLogout();
            }
            else{
                authStore.commit('lastActive',new Date()) 
            }
        },
        keepSession(){
            authStore.commit('lastActive',new Date());
            this.displaySessionAlert = false
        },
        sessionLogout(){
            window.removeEventListener('click', this.updateLastActive);
            window.removeEventListener('keydown', this.updateLastActive);
            authStore.commit('logoutIsAuth',false);
            this.displaySessionAlert = false
        },
        toastNow(severity, summary, detail) {
            this.toast.add({
                severity: severity,
                summary: summary,
                detail: detail,
                life: severity === 'error' ? 7000 : 5000,
            });
        },
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.png" : "images/logo-dark.png";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
        'SessionAlertModal': SessionAlertModal
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/App.scss';
</style>
